module.exports = __webpack_public_path__ + "assets/img/warrior-name-f0c8bb87.png";